import { z } from "zod";

export const championshipSchema = z.object({
  partitionId: z.string().optional(),
  parentId: z.string().optional(),
  name: z.string().min(1, "Name is required"),
  status: z.enum(
    ["not started", "ongoing", "published", "closed", "archived"],
    {
      errorMap: () => ({ message: "Status must be selected" }),
    },
  ),
  type: z.enum(["common", "bookmarked"], {
    errorMap: () => ({ message: "Type must be selected" }),
  }),
  startDate: z.string().min(1, "Start date is required"),
  endDate: z.string().min(1, "End date is required"),
  createdAt: z.string().min(1, "Creation date is required"),

  owner: z.object({
    L1: z.string().min(1, "L1 is required"),
    L2: z.string().optional(),
    L3: z.string().optional(),
    L4: z.string().optional(),
  }),
});
